const assignEn = {
    assignSubjectTeacher: require('../../lang/en/assign/AssignSubjectTeacher').default,
    assignCourseSubject: require('../../lang/en/assign/AssignCourseSubject').default,
};

export default assignEn;
